import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AdminHeader = ({ adminUser, onLogout, isSidebarOpen, setIsSidebarOpen, onSectionChange }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <header className="bg-card shadow-sm border-b border-border fixed top-0 left-0 right-0 z-50 h-16 flex items-center">
      <div className="w-full flex items-center justify-between px-4 sm:px-6">
        <div className="flex items-center space-x-4">
          {/* Mobile Toggle */}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="lg:hidden p-2 text-muted-foreground hover:bg-muted rounded-md transition-colors"
          >
            <Icon name={isSidebarOpen ? "X" : "Menu"} size={24} />
          </button>

          <div className="flex items-center space-x-3">
            {/* Logo Icon for Mobile/Tablet context */}
            <div className="w-8 h-8 flex items-center justify-center lg:hidden overflow-hidden">
              <img src="/favicon.ico" alt="Logo" className="w-full h-full object-contain" />
            </div>
            <h1 className="text-lg sm:text-xl font-semibold text-foreground truncate">Admin Dashboard</h1>
          </div>

          <div className="hidden md:flex items-center space-x-2 text-sm text-muted-foreground border-l border-border pl-4 ml-4">
            <span className="font-medium text-foreground">Nirmitee Associates</span>
          </div>
        </div>

        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* User Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-3 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary p-1 hover:bg-muted transition-colors"
            >
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center shadow-sm">
                <span className="text-primary-foreground font-medium text-sm">
                  {adminUser?.name?.charAt(0) || 'A'}
                </span>
              </div>
              <div className="hidden md:block text-left mr-2">
                <p className="text-sm font-medium text-foreground leading-none mb-0.5">{adminUser?.name || 'Admin User'}</p>
                <p className="text-xs text-muted-foreground leading-none">{adminUser?.role || 'Super Admin'}</p>
              </div>
              <Icon name="ChevronDown" size={16} className="text-muted-foreground hidden md:block" />
            </button>

            {showUserMenu && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)} />
                <div className="absolute right-0 mt-2 w-56 bg-card rounded-lg shadow-lg py-1 z-50 border border-border animate-fade-in-up">
                  <div className="px-4 py-3 border-b border-border bg-muted/30">
                    <p className="text-sm font-medium text-foreground">{adminUser?.name || 'Admin User'}</p>
                    <p className="text-xs text-muted-foreground truncate">{adminUser?.email || 'nirmitee.associates2919@gmail.com'}</p>
                  </div>
                  <div className="py-1">
                    <button 
                      onClick={() => {
                        setShowUserMenu(false);
                        if(onSectionChange) onSectionChange('settings');
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-foreground hover:bg-muted/50 flex items-center space-x-2"
                    >
                      <Icon name="Settings" size={16} />
                      <span>Settings</span>
                    </button>
                  </div>
                  <div className="border-t border-border py-1">
                    <button
                      onClick={() => {
                        setShowUserMenu(false);
                        onLogout();
                      }}
                      className="w-full text-left px-4 py-2 text-sm text-destructive hover:bg-destructive/10 flex items-center space-x-2"
                    >
                      <Icon name="LogOut" size={16} />
                      <span>Sign out</span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader; 